import { Head, usePage } from "@inertiajs/react";
import PlainLayout from "@/layouts/plain-layout";

function Index() {
  const { app_url } = usePage().props;

  return (
    <>
      <Head title="Velkommen" />
      <div className="container py-5">
        <h1 className="h3 mb-2">Velkommen</h1>
        <p className="text-muted mb-0">Obsero Core er klar.</p>
        <a href={app_url} className="btn btn-primary">
          Gå til app
        </a>
      </div>
    </>
  );
}

Index.layout = (page) => <PlainLayout>{page}</PlainLayout>;

export default Index;
